import {UPNBaseConfig} from './diagram-upn-base-config';
import {
  ActivitySettings,
  ActivityType,
  DiagramGeneralSettings,
  FlowlineSettings
} from '../diagram-type-styles.model';
import {MAPS_TYPES_ENUM as MAP_TYPES} from '../../../editor-interface/shared/models/map.model';

const defaultFlowlineShape = {w: 140, h: 0} as const;

export class UPNConfig extends UPNBaseConfig {
  activityShape = {w: 150, h: 100};

  readonly activityTypes: ActivityType[] = [
    {
      tooltip: 'ASIDE_L.UPN_DEFAULT_ACTIVITY_TOOLTIP',
      icon: 'activity_icon_v2',
      settings: (x?: number, y?: number) => this.activitySettings(x, y)
    }
  ];

  generalSettings(): DiagramGeneralSettings {
    return {
      ...super.generalSettings(),
      tagName: 'Process',
      canAutoGenerateDrilldown: true,
      allowedDrilldownSubtypes: [
        MAP_TYPES.UPN,
        MAP_TYPES.CUSTOMER_JOURNEY,
        MAP_TYPES.INTERACTION_FLOW,
        MAP_TYPES.AGENT_INSTRUCTION
      ]
    };
  }

  activitySettings(x?: number, y?: number): ActivitySettings {
    const baseSettings = super.activitySettings(x, y);
    const defaultActivityShape = this.activityShape;

    return {
      ...baseSettings,
      defaultActivityShape,
      position: {
        x: x - defaultActivityShape.w / 2,
        y: y - defaultActivityShape.h / 2,
        ...defaultActivityShape
      },
      dragHandlePosition: {x, y, ...defaultActivityShape},
      createActivityWithFlowline: true
    };
  }

  flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings {
    const baseSettings = super.flowlineSettings(x, y, id);
    const defaultActivityShape = this.activityShape;

    return {
      ...baseSettings,
      defaultFlowlineShape,
      config: {
        ...baseSettings.config,
        srcType: 'activity',
        tgtType: 'none',
        tgtPosition: {
          x: x + defaultActivityShape.w + defaultFlowlineShape.w,
          y: y + defaultActivityShape.h / 2
        },
        position: {
          connectionPoints: {
            exitX: 1,
            exitY: 0.5
          },
          offset: {x: 0, y: 0},
          x: 0,
          y: 60
        },
        srcId: Number(id) ?? null,
        tgtId: null
      }
    };
  }
}
